// Hero image utilities for landing page

export const HERO_IMAGE_DIMENSIONS = {
  width: 1780,
  height: 1540,
  aspectRatio: '1780 / 1540',
};

export function getHeroImageSrc(image: { src: string; alt?: string; mediaUri?: string } | string): string {
  if (typeof image === 'string') return image || '/replenico-bg-2.png';
  return image.src || '/replenico-bg-2.png';
}
